import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_BARCODE_REPORT_ASSET_IMAGES, GET_BARCODE_REPORT_COSTCENTER_DROPDOWN, GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES, GET_BARCODE_REPORT_EXCEL_DATA, GET_BARCODE_REPORT_GRID_DATA, GET_BARCODE_REPORT_MARKET_DROPDOWN, GET_BARCODE_REPORT_REGION_DROPDOWN, GET_BARCODE_REPORT_USER_DROPDOWN } from 'Store/Report/BarcodeReport/BarcodeReportType';
import { setBarcodeReportAssetImages, setBarcodeReportCostCenterDropdown, setBarcodeReportExcelData, setBarcodeReportGridData, setBarcodeReportMarketDropdown, setBarcodeReportRegionDropdown, setBarcodeReportUserDropdown } from 'Store/Report/BarcodeReport/BarcodeReportAction';
import AssetManagementApiService from 'Service/AssetManagement/AssetManagementApiService';

function* getBarcodeReportGridData(payload:any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.AssetManagement,
            endpoint: `barcodereport/dashboard`,
            payload: payload?.payload
        }

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setBarcodeReportGridData(response));
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* getBarcodeReportExcelData(payload?: any): any {
    try {
        yield put(globalLoaderText("Exporting Excel...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `barcodereport/dashboard/excel`,
            apiMethod: apiMethod.POST,
            payload: payload?.payload
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportExcelData({ response: response, status: "success" }))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportExcelData({ response: {}, status: "failed" }))
    }
}

function* getBarcodeReportUserDropdown(): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `barcodereport/grid/dropdown/user`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportUserDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportExcelData([]))
    }
}

function* getBarcodeReportRegionDropdown(): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `barcodereport/grid/dropdown/region`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportRegionDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportRegionDropdown([]))
    }
}

function* getBarcodeReportMarketDropdown(): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `barcodereport/grid/dropdown/market`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportMarketDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportMarketDropdown([]))
    }
}

function* getBarcodeReportCostCenterDropdown(): any {
    try {
        yield put(globalLoaderText("Fetching Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `barcodereport/grid/dropdown/costcenter`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportCostCenterDropdown(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportCostCenterDropdown([]))
    }
}

function* getBarcodeReportAssetImages(payload?: any): any {
    try {
        yield put(globalLoaderText("Fetching Asset Images...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `asset/fleet/barcode/getassetbarcodedetail/${payload?.payload}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportAssetImages(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportAssetImages({}))
    }
}

function* getBarcodeReportDashboardAssetImages(payload?: any): any {
    try {
        yield put(globalLoaderText("Fetching Dashboard Asset Images...."));
        let payloadData: IPayload = {
            apiType: apiType.FleetManagement,
            endpoint: `asset/fleet/barcode/getassetdetail/${payload?.payload}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(setBarcodeReportAssetImages(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBarcodeReportAssetImages({}))
    }
}

function* watchBarcodeReport() {
    yield takeEvery(GET_BARCODE_REPORT_GRID_DATA, getBarcodeReportGridData)
    yield takeEvery(GET_BARCODE_REPORT_EXCEL_DATA, getBarcodeReportExcelData)
    yield takeEvery(GET_BARCODE_REPORT_USER_DROPDOWN, getBarcodeReportUserDropdown)
    yield takeEvery(GET_BARCODE_REPORT_REGION_DROPDOWN, getBarcodeReportRegionDropdown)
    yield takeEvery(GET_BARCODE_REPORT_MARKET_DROPDOWN, getBarcodeReportMarketDropdown)
    yield takeEvery(GET_BARCODE_REPORT_COSTCENTER_DROPDOWN, getBarcodeReportCostCenterDropdown)
    yield takeEvery(GET_BARCODE_REPORT_ASSET_IMAGES, getBarcodeReportAssetImages)
    yield takeEvery(GET_BARCODE_REPORT_DASHBOARD_ASSET_IMAGES, getBarcodeReportDashboardAssetImages)
}

export default function* combinedSaga() {
    yield all([
        watchBarcodeReport()
    ])
}
